<template>
    <div class="bg-wrap">
        <Banner></Banner>
        <div class="btn">
            <label @click="toPay">我的账户</label>
            <label @click="toProcess">进度查询</label>
        </div>
        <div class="content">
            <div class="rule">
                <span>评审规则</span>
                <ul>
                    <li>系统将随机匹配给您7-8份病例幻灯</li>
                    <li>请您分别为每份病例进行评分及点评</li>
                    <li>每份病例的评分满分为100分，病例点评文字最少100个字</li>
                </ul>
            </div>
            <div class="case">
                <div class="item" v-for="(item,index) in cases" v-bind:key="index">
                    <div class="item-1">
                        <pdf
                                :page="1"
                                :src="item.work"
                                @progress="loadedRatio = $event"
                                @num-pages="pageTotalNum=$event"
                                style="width: 50px"
                        ></pdf>
                    </div>
                    <div class="item-2">
                        <span>{{item.name}}</span> - <span>{{item.hospital}}</span>
                    </div>
                    <div class="item-3">
                        <span>{{item.title}}</span>
                        <span class="btn" @click="toScore(item)" v-if="item.station==0">评审</span>
                        <span class="btn disable" v-else>已评审</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    import {ksdJudgeGetCase,ksdJudgeGetQuota} from "@/assets/js/api";
    import pdf from 'vue-pdf';
    import { MessageBox } from 'mint-ui';

    export default {
        name: "JudgeCase",
        data(){
            return{
                judgeId:this.$store.state.ksd_judgeId,
                cases:[],
                aNumber:8,
                bNumber:7,
                cNumber:7,
                station:"已完成"
            }
        },
        components:{
            Banner,
            pdf
        },
        methods:{
            toScore(docCase){
                this.$router.push({path:"judgeScore",query:{pdf:docCase.work,docId:docCase.docId,id:docCase.id}})
            },
            toPay(){
                this.$router.push("judgePay")
            },
            toProcess(){
                const message = "<div style='text-align: left;font-weight: bold;color: #333'>目标病例:"+this.aNumber+"例</div>"+
                                "<div style='text-align: left;font-weight: bold;color: #333'>已分配病例:"+this.bNumber+"例</div>"+
                                "<div style='text-align: left;font-weight: bold;color: #333'>已评审病例:"+this.cNumber+"例</div>"+
                                "<div style='text-align: left;font-weight: bold;color: #333'>评审状态:"+this.station+"</div>";

                MessageBox.confirm(
                    '',
                    {
                        title:'评审进度',
                        message:message,
                        showCancelButton:false
                    }
                     ).then(() => {
                });
            },
            async getCase(judgeId){
                const res = await ksdJudgeGetCase({judgeId})
                console.log(res)
                this.cases = res.data.data
            },
            async getQuota(judgeId){
                const res = await ksdJudgeGetQuota({judgeId})
                console.log(res,"quota")
                if(res.data.success){
                    this.aNumber = res.data.data.quota
                    this.bNumber = res.data.data.aNumber
                    this.cNumber = res.data.data.dNumber
                    this.station = res.data.data.station
                }
            }
        },
        mounted(){
            if(this.judgeId==null||this.judgeId==""){
                this.$router.replace("judgeLogin")
            }
            this.getQuota(this.judgeId)
            this.getCase(this.judgeId)
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
    }
    .bottom{
        display: flex;
        justify-content: flex-end;
        margin-bottom: -50px;
        img{
            width: 350px;
            height: 344px;
        }
    }
    .content{
        width: 90%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        position: relative;
    }
    .content .rule{
        text-align: left;
    }
    .content .rule span{
        font-size: 18px;
        font-weight: bold;
        color: #156098;
    }
    ul{
        margin: 5px 0;
        padding: 0 0 0 25px;
        font-size: 15px;
    }
    li{
        margin: 5px 0;
    }
    li::marker{
        color: #156098;
    }
    .case {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        margin-bottom: 20px;
    }
    .case .item{
        width: 48%;
        border: 1px #999 solid;
        margin-top: 10px;
        font-size: 15px;
    }
    .case .item .item-1{
        width: 100%;
        height: 100px;
        background: #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .case .item .item-2{
        text-align: left;
        margin: 5px 0 0 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .case .item .item-3{
        text-align: left;
        position: relative;
        margin: 5px;
        .btn{
            position: absolute;
            right: 0px;
            background: #156098;
            border-radius: 10px;
            color:#FFF;
            padding: 0 8px;
            font-size: 13px;
        }
        .disable{
            background: #e0e0e0;
            color: #000;

        }
    }
    .btn{
        text-align: right;
        label{
            background: #156098;
            padding: 2px 5px;
            color: #FFF;
            font-size: 14px;
            border-radius: 5px;
            margin-right: 10px;
        }
    }
</style>
